/*
 * @Descripttion: 所有的 状态
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-09 14:54:43
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-20 10:34:10
 */
import actionTypes from './actionTypes'

/**登录 √*/
export function LoginIn(data) {
  return {
    type: actionTypes.LoginIn,
    data: data
  }
}

/**保存用户信息  前端需要用户名 头像 等信息 用于持续的使用*/
export function SaveUser(data) {
  return {
    type: actionTypes.SaveUser,
    data: data
  }
}

/**更改当前激活房间*/
export function ChangeRoom(data) {
  return {
    type: actionTypes.ChangeRoom,
    data: data
  }
}
/**退出 √*/
export function LoginOut(data) {
  return {
    type: actionTypes.LoginOut,
    data: data
  }
}

/**注册*/
export function Register(data) {
  return {
    type: actionTypes.Register,
    data: data
  }
}

/**获取好友列表 传至 redux*/
export function GetFriendList(data) {
  return {
    type: actionTypes.GetFriendList,
    data: data
  }
}
/**获取好友申请列表 传至 redux*/
export function GetFriendApplication(data) {
  return {
    type: actionTypes.GetFriendApplication,
    data: data
  }
}
/**添加最近聊天会话*/
export function AddTalkList(data) {
  return {
    type: actionTypes.AddTalkList,
    data: data
  }
}

export function ResetTalkList() {
  return {
    type: actionTypes.ResetTalkList,
    data: {}
  }
}

// 若是群组名更新，修改
export function ChangeActiveRoomName(data) {
  return {
    type: actionTypes.ChangeActiveRoomName,
    data: data
  }
}

/**删除最近聊天好友*/
export function DeleteTalkList(data) {
  return {
    type: actionTypes.DeleteTalkList,
    data: data
  }
}
/**删除聊天好友*/
export function DeleteFriend(data) {
  return {
    type: actionTypes.DeleteFriend,
    data: data
  }
}
/**  来新消息啦   添加到消息存储树中*/
export function AddRoomMessage(data) {
  return {
    type: actionTypes.AddRoomMessage,
    data: data
  }
}

/** 来新消息啦   更新未读的条目数*/
export function AddRoomUnReadMsg(data) {
  return {
    type: actionTypes.AddRoomUnReadMsg,
    data: data
  }
}

/**删除   房间列表中的未读消息 数目*/
export function DeleteRoomUnReadMsg(data) {
  return {
    type: actionTypes.DeleteRoomUnReadMsg,
    data: data
  }
}

/**来新消息啦      把它跟新给  房间列表的最新消息    添加聊天室最后消息  房间置顶*/
export function AddRoomLastMsg(data) {
  return {
    type: actionTypes.AddRoomLastMsg,
    data: data
  }
}
/**
 * 存下用户信息的缓存 用来保存头像等信息
 * 读取好友列表时加载好友信息   点开房间时加载群成员信息
*/
export function AddUserCache(data) {
  return {
    type: actionTypes.AddUserCache,
    data: data
  }
}

/** export function FriendAction(data) {
/**   return {
/**     type:  actionTypes.FriendAction,
/**     data: data
/**   }
/** }*/

//存储找回密码时输入的用户名（邮箱）
export function saveUserName(data) {
  return {
    type: actionTypes.UserName,
    data: data
  }
}


//存储找回密码时查找出来的问题1
export function saveQuestionOne(data) {
  return {
    type: actionTypes.QuestionOne,
    data: data
  }
}

//存储找回密码时查找出来的问题2
export function saveQuestionTwo(data) {
  return {
    type: actionTypes.QuestionTwo,
    data: data
  }
}

//存储需要展示的遥感信息数据
export function saveSensingDisplay(data) {
  return {
    type: actionTypes.SensingDisplay,
    data: data
  }
}

//存储需要下载的遥感信息数据
export function saveSensingDownload(data) {
  return {
    type: actionTypes.SensingDownload,
    data: data
  }
}
//储存客服消息
export function saveOnlineService(data) {
  console.log(data)
  return {
    type: actionTypes.OnlineServiceList,
    onlineServiceList: data
  }
}
//储存客服消息
export function saveOnlineServiceId(data) {
  return {
    type: actionTypes.OnlineServiceId,
    onlineServiceId: data
  }
}


/* 保存浙大相关登录信息 */
export function ZD_SaveUser(data) {
  return {
    type: actionTypes.ZD_SaveUser,
    data: data
  }
}

/* 控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复 */
export function ProcessProductHideAndShow(data) {
  return {
    type: actionTypes.ProcessProductHideAndShow,
    data: data
  }
}
/* 控制生产定制中，检索结果贴球时进行其他框的隐藏和后续的恢复(input过程) */
export function ProcessProduct_SourceInputHideAndShow(data) {
  return {
    type: actionTypes.ProcessProduct_SourceInputHideAndShow,
    data: data
  }
}

export function SetProducerFlowId(flowId) {
  return {
    type: actionTypes.SetProducerFlowId,
    producerFlowId: flowId
  }
}

export function SetProducerFlow(producerFlow) {
  return {
    type: actionTypes.SetProducerFlow,
    producerFlow: producerFlow
  }
}

export function SetSourceDataList(sourceDataList) {
  return {
    type: actionTypes.SetSourceDataList,
    sourceDataList: sourceDataList
  }
}

export function SetResourcePage({ courseId, isDetail, courseType, currentPage }) {
  return {
    type: actionTypes.SetResourcePage,
    collectionId: courseId,
    showTypeDetail: isDetail,
    typeCurPage: currentPage,
    courseType: courseType,
  }
}

export function SetInsClass(classObj) {
  return {
    type: actionTypes.SetInsClass,
    classObj: classObj,
  }
}

export function SetUserMsg(msg) {
  return {
    type: actionTypes.SetUserMsg,
    userMsg: msg
  }
}

export function SetSearchRules02(rules) {
  return {
    type: actionTypes.searchRules02,
    searchRules02: rules
  }
}







